/**
 * Constantes da aplicação
 * Valores padrão quando variáveis de ambiente não estão definidas (ex.: desenvolvimento local)
 */

/** URL base do backend quando REACT_APP_ADMIN_API_URL não está definida */
export const DEFAULT_API_BASE_URL = 'http://localhost:4001';

/** Produto padrão (control plane) — alinhado ao backend DEFAULT_PRODUCT_ID */
export const DEFAULT_PRODUCT_ID = process.env.REACT_APP_DEFAULT_PRODUCT_ID?.trim() || 'vover-app';
